// extracted by mini-css-extract-plugin
export default {"loading":"Loading-dots_loading__qw6V7","dot_container":"Loading-dots_dot_container__sWJQ3","dot":"Loading-dots_dot__IdiJ-","bounce":"Loading-dots_bounce__MiN8U"};